
<div class="px-4 py-3 bg-white w-full mt-3 grid border border-gray-200 rounded" *ngIf="dataLoading">
    <div class="text-gray-600 w-full text-center">
        <span class="py-1 font-bold text-2xl">
            <fa-icon class="mr-2" [icon]="faSpinner" [animation]="'spin-pulse'"></fa-icon>
            {{dataLoadingMsg}}
        </span>
    </div>
  </div>
<div *ngIf="dataEmpty && !dataLoading" 
class="w-full h-3/4 flex items-center bg-white"
[ngStyle]="{'min-height': height}"
>
    <div class="m-auto w-fit text-center py-6">
      <img class="m-auto" src="assets/svg/empty-data.svg" alt="">
      <h3 class="text-gray-500 mt-2 font-light">{{dataEmptyMsg}}</h3>
    </div>
</div>